<script setup lang="ts">
import { computed } from 'vue';
import { clinicalAuthorLine, type ClinicalAuthor } from '@/utils/clinical-author';

// "Registrado por <nombre> · <rol o carrera> · <fecha y hora>" under a registro
// clínico; nothing when its Autor is unknown.
const props = withDefaults(defineProps<{
  author?: ClinicalAuthor | null;
  at?: string | null;
  label?: string;
}>(), { author: null, at: null, label: 'Registrado por' });

const line = computed(() => clinicalAuthorLine(props.author, props.at, props.label));
</script>
<template>
  <div
    v-if="line"
    class="text-caption text-medium-emphasis"
  >
    {{ line }}
  </div>
</template>
